import script from "./PictureView.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureView.vue?vue&type=script&setup=true&lang=js"

import "./PictureView.vue?vue&type=style&index=0&id=4a6170c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6170c2"]])

export default __exports__